import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "IT Support & Computerservice Beverwijk | Computheer";
const DEFAULT_DESCRIPTION = "IT Support vanaf €15/mnd in Beverwijk en omgeving — vaste hulp, virusbeveiliging en onderhoud. Ook voor losse computerreparaties.";
const DEFAULT_OG_DESCRIPTION = "IT Support-abonnement vanaf €15/maand. Persoonlijk, transparant en zonder verborgen kosten — voor particulieren en bedrijven.";
const DEFAULT_TW_DESCRIPTION = "IT Support-abonnement vanaf €15/maand in Beverwijk. 4.9 sterren op Google.";
const KEYWORDS = "IT support abonnement, computer abonnement, zakelijk IT beheer, IT beheer Beverwijk, computer onderhoud abonnement, computer reparatie Beverwijk, laptop reparatie Beverwijk, virus verwijderen Beverwijk, data herstel, computerhulp Beverwijk, hulp op afstand, Bitdefender abonnement";

const titles = {
  "/": DEFAULT_TITLE,
  "/it-support": "IT Support-abonnement vanaf €15/mnd | Computheer Beverwijk",
  "/zakelijk": "Zakelijk IT-beheer voor MKB & ZZP | Computheer",
  "/diensten": "Computer & Laptop Reparatie Beverwijk | Computheer",
  "/computer-reparaties": "Computer reparaties | Computheer — Vakkundig & eerlijk",
  "/hulp-op-afstand": "Hulp op afstand | Computheer — Direct geholpen",
  "/contact": "Contact | Computheer — Neem contact op",
};

const descriptions = {
  "/": DEFAULT_DESCRIPTION,
  "/it-support": "IT Support-abonnement vanaf €15/maand — Bitdefender, onderhoud en onbeperkte hulp op afstand. Voor particulieren en bedrijven.",
  "/zakelijk": "Volledig IT-beheer voor MKB en ZZP: netwerkbeheer, security, backup en support met vaste maandprijs — vanaf €25 per maand.",
  "/diensten": "Snelle, eerlijke computer- en laptopreparatie in Beverwijk. Virus verwijderen, data herstel, netwerkproblemen. Gratis diagnose, vanaf €45.",
  "/computer-reparaties": "Vakkundige computer- en laptopreparaties met vooraf duidelijke prijsopgave. 3 maanden garantie op alle reparaties.",
  "/hulp-op-afstand": "Direct geholpen via veilige externe verbinding met Splashtop SOS. Snel, voordelig en zonder wachttijd.",
  "/contact": "Neem contact op met Computheer in Beverwijk. Telefonisch, via e-mail of via het contactformulier. Wij reageren binnen 24 uur.",
};

const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = titles[pathname] || titles["/"];
    const description = descriptions[pathname] || descriptions["/"];
    document.title = title;

    const setMeta = (name, content, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", KEYWORDS);
    setMeta("og:title", title, true);
    setMeta("og:description", pathname === "/" ? DEFAULT_OG_DESCRIPTION : description, true);
    setMeta("og:url", window.location.href, true);
    setMeta("twitter:title", title);
    setMeta("twitter:description", pathname === "/" ? DEFAULT_TW_DESCRIPTION : description);

    // Track page view (internal counter + GA4)
    try {
      const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
      fetch(`${API}/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: pathname, referrer: document.referrer || "" }),
      }).catch(() => {});
      // GA4 page view (if loaded)
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_path: pathname,
          page_title: title,
        });
      }
    } catch {}
  }, [pathname]);

  return null;
};

export default SEO;
